var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(_vm.switchLoginFlag == 1)?_c('phone-code-login'):_c('number-code-login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }